import script from "./MaterialClosingView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialClosingView.vue?vue&type=script&setup=true&lang=js"

import "./MaterialClosingView.vue?vue&type=style&index=0&id=c3fef84e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3fef84e"]])

export default __exports__